
function Contact() {
  return (
    <div className="contact-container">
      <h1>Contactez-nous</h1>
      <p>N'hésitez pas à nous contacter sur nos réseaux sociaux, ou en nous envoyant un mail !</p>
      <p>
        <strong>Email :</strong> <a href="mailto:redglitterproductions@gmail.com">redglitterproductions@gmail.com</a>
      </p>
    </div>
  );
}

export default Contact;